import cn from 'classnames';
import { useState } from 'react';

import MapContainerStores from '../MapContainer/MapContainerStores';

import StoresAccordion from './StoresAccordion';
import styles from './StoresLayout.module.scss';

export default function StoresLayout({ stores, regions }) {
  const [store, setStore] = useState();

  return (
    <section className={styles.section}>
      <div className={cn(styles.column, styles.map)}>
        <MapContainerStores stores={stores} store={store} />
      </div>
      <div className={styles.column}>
        <StoresAccordion stores={stores} regions={regions} setStore={setStore} />
      </div>
    </section>
  );
}
